// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1IWQZ","field":"styles_field__3L3Ps","fieldCol":"styles_fieldCol__Mtgls","diffCol":"styles_diffCol__3Pl1E","diff":"styles_diff__2p0SV"};